<template>
    <BreadCrumb PageTitle="Liste des propositions de réponse" />
    <ListePropositionReponse />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListePropositionReponse from "@/components/PropositionReponse/ListePropositionReponse.vue";
  
  
  export default defineComponent({
    name: "ListePropositionReponsePage",
    components: {
      BreadCrumb,
      ListePropositionReponse,
    },
  });
  </script>